import { Stack } from '@mui/material';
import useFontStyles from 'common/fontStyles';
import { useTranslation } from 'react-i18next';

import useColorsStyles from 'common/colors';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import useStickerStyles from './styles/Sticker.styles';

const ShowMe = (props) => {
    const { asset, info, size, disabled } = props;
    const { classes, cx } = useStickerStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: colors } = useColorsStyles();
    const { classes: font } = useFontStyles();
    const { classes: onlive } = useOnliveStyles();

    const { t } = useTranslation();

    const rootStyle = {};
    if (asset.color) {
        rootStyle.backgroundColor = asset.color;
    }
    const showMePage = () => {
        if (!info) {
            window.open(asset.url, '_blank', 'noopener,noreferrer');
        }
    };

    const manageClick = () => {
        if (!disabled) {
            showMePage();
        }
    };

    return (
        <Stack
            direction="column"
            className={cx(
                flexBox.borderRadius2,
                flexBox.relative,
                flexBox.overflowHidden,
                flexBox.borderBox,
                colors.bgPaper,
                font.bold,
                flexBox.w100,
                classes.width,
                onlive.boxShadowWeb,
                classes.minWidth,
            )}
        >
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                className={cx(
                    colors.bgSecondaryMain,
                    colors.textSecondaryMainContrast,
                    flexBox.padding01,
                    flexBox.textAlignCenter,
                    flexBox.wrap,
                    classes.title,
                )}
            >
                <span className={cx(classes.titleText, font.bold)}>{asset.name.toUpperCase()}</span>
            </Stack>

            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                className={cx(flexBox.grow1, flexBox.textAlignCenter, flexBox.padding2)}
                style={rootStyle}
            >
                <CustomTooltip
                    arrow
                    disableHoverListener={size !== 'medium'}
                    title={asset.text}
                    aria-label="edit profile"
                    placement="bottom"
                >
                    <span className={cx(classes.bodyText, font.clamp, font.clampLine3)}>{asset.text}</span>
                </CustomTooltip>
            </Stack>

            <Stack
                aria-hidden={true}
                onClick={manageClick}
                direction="row"
                justifyContent="center"
                alignItems="center"
                className={cx(
                    classes.proceedButton,
                    flexBox.borderBottomRadius2,
                    flexBox.cursorPointer,
                    flexBox.w100,
                    flexBox.textAlignCenter,
                    font.bold,
                    'primary',
                    size,
                )}
            >
                {t('callToAction.callToActionItem.showMe').toUpperCase()}
            </Stack>
        </Stack>
    );
};

export default ShowMe;
